import { memo } from "react";

function DeliveryPopupMarker(props) {
  const shiftLeft = props.stopNo && props.stopNo < 10 ? 0 : -3;
  return (
    <svg
      width={26}
      height={24}
      viewBox={`0 0 26 24`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="1"
        width={23}
        height={22}
        rx={11.5}
        fill="none"
        stroke="white"
        strokeWidth={1}
      />

      <text
        id={10}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={12}
        fontWeight={500}
        fill="white"
      >
        <tspan x={9.5 + shiftLeft} y={16}>
          {props.stopNo}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(DeliveryPopupMarker);
